const GLYPHS = [
  ["Aries", "♈"], ["Taurus", "♉"], ["Gemini", "♊"], ["Cancer", "♋"],
  ["Leo", "♌"], ["Virgo", "♍"], ["Libra", "♎"], ["Scorpio", "♏"],
  ["Sagittarius", "♐"], ["Capricorn", "♑"], ["Aquarius", "♒"], ["Pisces", "♓"],
];

export function ZodiacStrip() {
  const row = [...GLYPHS, ...GLYPHS];
  return (
    <div className="relative overflow-hidden border-y border-amber-500/12 bg-[#0A0E20]/60 py-5" data-testid="zodiac-strip">
      <div className="marquee-track gap-10 px-5">
        {row.map(([name, g], i) => (
          <div key={i} className="flex items-center gap-3 shrink-0">
            <span className="zodiac-glyph text-2xl leading-none">{g}</span>
            <span className="text-xs uppercase tracking-[0.25em] text-slate-500">{name}</span>
            <span className="text-amber-500/30">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ZodiacWheel({ className = "" }) {
  return (
    <div className={`pointer-events-none select-none ${className}`} aria-hidden>
      <div className="relative slowspin" style={{ width: "100%", height: "100%" }}>
        <svg viewBox="0 0 400 400" className="w-full h-full">
          <defs>
            <radialGradient id="wheelGlow" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="rgba(229,193,88,0.10)" />
              <stop offset="70%" stopColor="rgba(67,56,202,0.06)" />
              <stop offset="100%" stopColor="transparent" />
            </radialGradient>
          </defs>
          <circle cx="200" cy="200" r="198" fill="url(#wheelGlow)" />
          {[196, 150, 104].map((r, idx) => (
            <circle key={idx} cx="200" cy="200" r={r} fill="none" stroke="rgba(229,193,88,0.18)" strokeWidth="1" />
          ))}
          {GLYPHS.map(([, g], i) => {
            const a = (i / 12) * Math.PI * 2 - Math.PI / 2;
            const x = 200 + Math.cos(a) * 173;
            const y = 200 + Math.sin(a) * 173;
            const lx = 200 + Math.cos(a) * 150;
            const ly = 200 + Math.sin(a) * 150;
            return (
              <g key={i}>
                <line x1="200" y1="200" x2={lx} y2={ly} stroke="rgba(229,193,88,0.10)" strokeWidth="1" />
                <text x={x} y={y} fontSize="20" fill="rgba(229,193,88,0.5)" textAnchor="middle" dominantBaseline="middle"
                  fontFamily="Cormorant Garamond, serif">{g}</text>
              </g>
            );
          })}
          <circle cx="200" cy="200" r="6" fill="rgba(229,193,88,0.6)" />
        </svg>
      </div>
    </div>
  );
}
